export const en = {
  globals: {},
  auth: {
    emailId: "Email Id",
    password: "Password",
    remember: "Remember me",
    forgotPassword: "Forgot Password",
    oldPass: "Old Password",
    confmPas: "Confirm Password",
    otpVerification: "OTP Verification",
    verify: "Verify",
    resendOtp: "Resend Otp",
    login: "Sign In",
    resendPass: "Reset Password",
    editProfile: "Edit Profile",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone Number",
    loginToSura: "Log in to Sura Trade Admin",
    emailAddress: "Email Address",
    verifyOtp: "Verify OTP",
    otpExpire: "The verification code will expire in",
    otpResent: "OTP Resent Successfully",
  },
  main: {
    totalCustomers: "Total Customers",
    totalVendors: "Total Vendors",
    totalOrders: "Ongoing Orders",
    completedOrders: "Completed Orders",
    cancelledOrders: "Cancelled Orders",
    totalCategories: "Total Categories",
    totalSubCategories: "Total Sub-Categories",
    totalRevenue: "Total Revenue",
    totalProductsListed: "Total Products Listed",
    exportCsv: "Export Csv",
    sNo: "S.NO",
    image: "Image",
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    email: "Email",
    businessName: "Business Name",
    industryType: "Industry Type",
    address: "Address",
    manageAccount: "Manage Account",
    reject: "Reject",
    accept: "Accept",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    deactivate: "Deactivated",
    search: "Search Here",
    accountStatus: "Account Status",
    actions: "Actions",
    name: "Name",
    subCategory: "Sub-Category",
    addCategory: "Add Category",
    viewSubCategories: "View Sub-Categories",
    selectCategory: "Select Category",
    selectSubCategory: "Select Sub-Category",
    clearFilter: "Clear Filter",
    addProduct: "Add Product",
    productName: "Product Name",
    vendorName: "vendor Name",
    subCategoryName: "Sub-Category Name",
    parentCategory: "Parent Category",
    manageProduct: "Manage Product",
    status: "Status",
    todayDeals: "Today Deals",
    bestDeals: "Best Deals",
    customerName: "Customer Name",
    inProgress: "In Progress",
    category: "Category",
    productQuantity: "Product Quantity",
    price: "Price",
    specificReq: "Specific Requirement",
    chat: "Chat",
    quoteStatus: "Quote Status",
    sendQuote: "Send Quote",
    deliveryConditions: "Delivery Conditions",
    shippingCharge: "Shipping charge",
    freeDelivery: "Free delivery",
    payment: "Payment",
    refundable: "Refundable",
    nonRefundable: "Non-Refundable",
    update: "Update",
    cancel: "Cancel",
    orderId: "Order ID",
    date: "Date",
    refundAmount: "Refund Amount",
    amountSetByVendor: "Amount set by Vendor",
    refund: "Refund",
    refundPayment: "Refund Payment",
    addBanner: "Add Banner",
    banner: "Banner",
    discountName: "Discount Name",
    discountPercentage: "Discount percentage",
    description: "Description",
    type: "Type",
    bannerType: "Banner Type",
    startDate: "Start Date",
    endDate: "End Date",
    addDiscount: "Add Discount",
    onGoing: "On Going",
    completed: "Completed",
    orderTrackId: "Order Track Id",
    userName: "User Name",
    subTotal: "Sub Total",
    totalCost: "Total Cost",
    deliveryFees: "Delivery Fees",
    shippingAddress: "Shipping Address",
    contact: "Contact",
    orderStatus: "Order Status",
    paymentStatus: "Payment Status",
    orderPlaced: "Order Placed",
    shipping: "Shipping",
    delivered: "Delivered",
    extraAmountPay: "Extra Amount to pay",
    totalCostPay: "Total Cost to Pay",
    acceptReject: "Accept/Reject",
    inbox: "Inbox",
    totalPayments: "Total Payments",
    pendingPayments: "Pending Payments",
    amountPaidToVendor: "Amount Paid to Vendor",
    makePayment: "Make Payment",
    pay: "Pay",
    addNotification: "Add Notification",
    sentTo: "Sent To",
    title: "Title",
    messages: "Messages",
    delete: "Delete",
    addSubAdmin: "Add Sub-Admin",
    role: "Role",
    add: "Add",
    platformCommission: "Platform Commission",
    tax: "Tax",
    responseTime: "Response Time (hours)",
    avgDeliveryTime: "Average Delivery time (days)",
    save: "Save",
    orderCancellationTime: "Order Cancellation Time (hours)",
    orderExchangeTime: "Order Exchange Time (days)",
    serviceFee: "Service Fee",
    general: "General",
    timing: "Timing",
    contactSupport: "Contact Support",
    privacyPolicy: "Privacy Policy",
    agreement: "Agreement",
    terms: "Term & Conditions",
    cookiesPolicy: "Cookies Policy",
    about: "About",
    dataDeletion: "Data Deletion Policy",
    conversionRate: "Conversion Rate",
    conversionUsdToAed: "Conversion rate from USD to AED",
    viewUserProfile: "View Customer Profile",
    back: "Back",
    details: "Details",
    documents: "Documents",
    city: "City",
    pinCode: "Pin Code",
    uploadedDocs: "Uploaded Documents",
    clickToDownload: "Click to download PDF",
    selectIndustry: "Select Industry Type",
    categoryEn: "Category Name in English",
    categoryAr: "Category Name in Arabic",
    categoryRu: "Category Name in Russian",
    addCat: "Add Category",
    editCat: "Edit Category",
    productNameEn: "Product Name( English )",
    productNameAr: "Product Name( Arabic )",
    productNameRu: "Product Name( Russian )",
    gradeEn: "Grade ( English )",
    gradeAr: "Grade ( Arabic )",
    gradeRu: "Grade ( Russian )",
    modelEn: "Modal no. ( English )",
    modelAr: "Modal no. ( Arabic )",
    modelRu: "Modal no. ( Russian )",
    images: "Images",
    editProduct: "Edit Product",
    shelfEn: "Shelf Life ( English )",
    shelfAr: "Shelf Life ( Arabic )",
    shelfRu: "Shelf Life ( Russian )",
    styleEn: "Style ( English )",
    styleAr: "Style ( Arabic )",
    styleRu: "Style ( Russian )",
    productTypeEn: "Product Type ( English )",
    producTypeAr: "Product Type ( Arabic )",
    productTypeRu: "Product Type ( Russian )",
    placeOfOrigin: "Place of origin",
    stock: "Available Stock",
    priceUnit: "Price Unit",
    select: "Select",
    makeAsPackage: "Make as Package",
    quantityPerUnit: "Quantity Per Unit",
    pricePerUnit: "Price per unit",
    minPerchaseQty: "Min Purchase Quantity ( in unit )",
    descEng: "Description ( English)",
    descAr: "Description ( Arabic )",
    descRu: "Description ( Russian )",
    bulkPricing: "Bulk Pricing",
    minQty: " Min Quantity",
    maxQty: "Max Quantity",
    remove: "Remove",
    addBulk: "Add Bulk Pricing",
    pricePerKg: "Price per kg",
    pricePerLiter: "Price per Liter",
    minQtyKg: " Min Purchase Quantity ( in Kg )",
    minQtyLiter: "Min Purchase Quantity ( in Liter )",
    selectDateRange: "Select Date Range",
    quotedSubmitted: "Quote submitted",
    quoteNotSubmitted: "Quote not submitted",
    editBanner: "Edit Banner",
    createBannerFor: "Create Banner For",
    discountNameEn: " Discount Name in English",
    discountNameAr: "Discount Name in Arabic",
    discountNameRu: "Discount Name in Russia",
    discountPer: "Discount Percentage",
    addBannerImage: "Add Banner Image",
    orderDetails: "Order Details",
    customerDetails: "Customer Details",
    productsOrdered: "Products ordered",
    regNo: "Registered Number",
    orderedQty: "Ordered Quantity",
    myProfile: "My Profile",
    changePassword: "Change Password",
    logout: "Logout",
    currentPass: "Current Password",
    newPassword: "New Password",
    confirmPass: "Confirm Password",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",
    customerRejected: "Customer Rejected Successfully",
    customerAccepted: "Customer Accepted Successfully",
    userDeleted: "User deleted successfully",
    customerActivated: "Customer Activated Successfully",
    customerDeactivated: "Customer Deactivated Successfully",
    requestReceived: "Request Received",
    vendorAccepted: "Vendor Accepted",
    vendorRejected: "Vendor Rejected",
    pickupScheduled: "Pickup Scheduled",
    pickedUp: "Picked Up",
    inTransit: "In Transit",
    receivedByVendor: "Received by Vendor",
    returnComplete: "Return Completed",
    vendorAcceptedReq: "Vendor Accepted Request",
    vendorRejectedReq: "Vendor Rejected Request",
    ExchangeInit: "Exchange Initiated",
    itemPickedUp: "Item Picked Up",
    itemInTransit: "Item In Transit",
    itemReceivedByVendor: "Item Received by Vendor",
    replacementDispatched: "Replacement Dispatched",
    replacementDelivered: "Replacement Delivered",
    exchangeComplete: "Exchange Complete",
    returnStatusUpdatedTo: "Return status updated to",
    exchangeStatusUpdatedTo: "Exchange status updated to",
    orderAcceptedSuccessFully: "Order accepted successfully",
    orderRejectedSuccessfully: "Order rejected successfully",
    updatedSuccess: "Updated successfully",
    send: "Send",
    editVendor: "Edit Vendor",
    vendorProfile: "Vendor Profile",
    profileDetails: "Profile Details",
    docs: "Documents",
    areYouSure: "Are you sure you want to delete this",
    yes: "Yes",
    no: "No",
    productAdded: "Product Added Successfully",
    productUpdated: "Product Updated Successfully",
    productDetails: "productDetails",
    sendQuotation: "Send Quotation",
    chatInbox: "Chat Inbox",
    typeMessage: "Type your message...",
    chatDetails: "Chat Details",
    timeFrame: "Time Frame (hours)",
    selectProduct: "Select Product",
    lastWeek: "Last Week",
    lastMonth: "Last Month",
    lastYear: "Last Year",
    bannerDetails: "View Banners Details",
    uploadBanner: "Please upload an image for the banner",
    bannerUpdated: "Banner Updated Successfully",
    bannerAdded: "Banner Added Successfully",
    discountDetails: "View Discount Details",
    discountAdded: "Discount Added Successfully",
    discountUpdated: "Discount Updated Successfully",
    editDiscount: "Edit Discount",
    accepted: "Accepted",
    refundedSuccess: "Refunded successfully",
    exchangeRefunds: "Exchange Refunds",
    returnRefunds: "Return Refunds",
    refunded: "Refunded",
    notificationTitle: "Notification Title",
    notificationMessage: "Notification Message",
    receiverType: "Select Receiver Type",
    notificationType: "Select Notification Type",
    notification: "Notification",
    settingsAdded: "Settings added successfully",
    settingsUpdated: "Settings updated successfully",
    addSettings: "Add Setting",
    selectType: "Select Type",
    taxPer: "Tax (%)",
    commissionPer: "Platform Commision (%)",
    cmsUpdated: "Contact Support Updated Successfully",
    conversionUpdated: "Conversion rate updated successfully",
    selectRole: "Please Select a Role",
    editSubAdmin: "Edit Sub-Admin",
    addRole: "Add Role",
    selectRole1: "Select Role",
    module: "Module",
    addEdit: "Add/Edit",
    view: "View",
    loginSuccess: "Logged in successfully.",
    profileUpdated: "Profile Updated Successfully.",
    subAdminUpdated: "Sub Admin Status Updated successfully.",
    broadcast: "Broadcast",
    user: "User",
    vendor: "Vendor",
    selectAll: "Select All",
    remarks: "Remarks",
    amount: "Amount",
    showing: "Showing",
    items: "Items",
    exchange: "Exchange",
    return: "Return",
    updateDiscount: "Update Discount",
    discountActivated: "Discount Activated Successfully",
    discountDeactivated: "Discount Deactivated Successfully",
    passChanged: "Password changed successfully",
  },
  dashboard: {},
  sideBar: {
    dashboard: "Dashboard",
    registration: "Registration",
    manageCustomers: "Manage Customers",
    manageVendors: "Manage Vendors",
    manageCategories: "Manage Categories",
    manageProducts: "Manage Products",
    manageQuotes: "Manage Quotes",
    manageBanners: "Manage Banners",
    manageDiscount: "Manage Discount",
    manageOrders: "Manage Orders",
    manageReturnExchange: "Manage Return & Exchange",
    manageRefunds: "Manage Refunds",
    manageChats: "Manage Chats",
    managePayments: "Manage Payments",
    analytics: "Analytics",
    notificationManagement: "Notification Management",
    manageSubAdmin: "Manage Sub Admin",
    settings: "Settings",
    general: "General",
    manageCms: "Manage CMS",
    conversionRate: "Conversion Rate",
  },
  error: {
    required: "This field is required",
    validation1: "Please select a valid video",
    maxValidation: "Maximum 80 character are allowed",
    minValidation: "Minimum 2 characters are required",
    noData: "No results found",
    titlereq: "Title is required",
    descReq: "Description is required",
    noFaq: "No faq's listing found",
    emailReq: "Email is required!",
    validEmail: "Enter a valid email address!",
    firstReq: "First name is required",
    lastReq: "Last name is required",
    phoneReq: "Phone number is required",
    minPhone: "Phone number must be at least 6 digits",
    maxPhone: "Phone number must be at least 16 digits",
    subAdminCreated: "Sub-admin created successfully",
    subAdminUpdate: "Sub-admin updated successfully",
    userUpdate: "User updated successfully",
    statusUpdate: "Status updated successfully",
    subAdminDel: "Sub-admin deleted successfully",
    userDel: "User deleted successfully",
    max100: "Maximum 100 character are allowed",
    max250: "Maximum 250 character are allowed",
    max500: "Maximum 500 character are allowed",
    catAdd: "Category added successfully",
    catUpdate: "Category updated successfully",
    settingUpdate: "Settings updated successfully",
    faqAdd: "FAQ added successfully",
    faqDel: "FAQ deleted successfully",
    cmsUpdate: "CMS updated successfully",
    messageReq: "Message is required",
    notiAdd: "Notification added successfully",
    notiDel: "Notification deleted successfully",
    logutReq: "Are you sure, you want to logout?",
    noUserFound: "No User Found",
    noVendorFound: "No Vendor Found",
    noSubFound: "No Sub Category Found",
    noChatFound: "No Chats Found",
    noDocs: "No document available.",
    noImage: "Please upload an image",
    incorrectOtp: "Incorrect OTP. Please try again.",
    enterOtp: "Please enter OTP",
    noEmoji: "Emojis are not allowed in the email address",
    newPassReq: "New password is required.",
    passValid:
      "Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&)",
    newCannotBeOld: "New password cannot be the same as the current password.",
    mustMatch: "Passwords must match.",
    confirmPassReq: "Confirm password is required.",
    passReset: "Password reset successfully",
    max40: "Maximum 80 character are allowed",
    pleaseUploadImage: "Please Upload Images",
    fillMinimum: "Please fill in minimum quantity",
    fillMaximum: "Please fill in maximum quantity",
    fillPrice: "Please fill in price",
    max10Image: "Maximum 10 images are allowed",
    pleaseWrite: "Please write something",
    minBanner: "Banner image minimum dimensions must be 498×500",
    atLeast1Receiver: "Please select at least one receiver",
    oneNotificationType: "Please select at least one Notification Type",
    currentPassRequired: "Current password is required",
    min8: "Minimum 8 characters are required",
  },
  messages: {},
};
